// extracted by mini-css-extract-plugin
export default {"wrapper":"ContainerPityTimer_wrapper","label":"ContainerPityTimer_label"};